import {
    Box,
    Typography,
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails, IconButton,
    Chip,
    Divider,
    Stack,
 
} from "@mui/material";

import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";

import React, {useEffect, useState} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {useDispatch, useSelector} from "react-redux";
import {approveRequestedAppointment, changeAppointmentStatus, getAllRequestedAppointment} from "../../../store/crm/appointment";
import {MySwal, successConfirmation, successConfirmationn} from "../../../services/utills";
import {confirmationButton} from "../../../pages/crm/call-logs/Appointment";
// import Loader from "../loader/loader";
import AppointmentReschedule from "../../../components/card-appointment/AppointmentReschedule";
import {scrollCSS} from "../../../App";
import moment from "moment";
import Waveloading from "../../../pages/loading/Waveloading";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DateRange from "../../../components/date-range/date-range";
import { mySwalButtonCancel, mySwalButtonYes } from "../../../components/card-appointment/CardAppointment";
import DateRangeReport from "../../../components/date-range/date-range-report";
import { getUserDetails } from "../../../store/auth";
import DateRangeRequest from "../../../components/date-range/date-range-request";
import toast from "react-hot-toast";

const RequestedAppointment = () => {
    const [loading, setLoading] = useState(false);
    const [isMouseEnter, setIsMouseEnter] = useState(false);
    const [expanded, setExpanded] = useState({}); 
      const [localStartDate, setLocalStartDate] = useState();
      const [localEndDate, setLocalEndDate] = useState();

    const crmAppointmentStore = useSelector(state => state?.crmAppointmentStore)
    const {requestedAppointment = []} = crmAppointmentStore

     
      const handleDateChange = async (start, end) => {
    setLocalStartDate(start);
    setLocalEndDate(end);
    //console.log("data comming",start, end)
    // await fetchData(start, end);
  };

//   const fetchData = ()=> {
//      setLoading(true)
//      dispatch(getAllRequestedAppointment({
//         start_date: localStartDate ? moment(localStartDate).format("YYYY-MM-DD") : undefined,
//         end_date: localEndDate ? moment(localEndDate).format("YYYY-MM-DD") : undefined,
//       })
//     )
//     setLoading(false);

//   }
    const dispatch = useDispatch()
  useEffect(() => {
  (async () => {
    setLoading(true);
    await dispatch(
      getAllRequestedAppointment({
        start_date: localStartDate ? moment(localStartDate).format("YYYY-MM-DD") : undefined,
        end_date: localEndDate ? moment(localEndDate).format("YYYY-MM-DD") : undefined,
      })
    );  
    setLoading(false);
  })();
}, [localStartDate, localEndDate]);
 

    // Update handleAccordionChange to toggle specific section
    const handleAccordionChange = (id) => { 
        // Toggle the expanded state of the specific appointment by its ID
        setExpanded(prevExpanded => ({
            ...prevExpanded,
            [id]: !prevExpanded[id], // If true, set to false, if false, set to true
        }));
    };

    const handleAccept = async (id) => {
     
        
            setLoading(true)
            let {payload} = await dispatch(approveRequestedAppointment(
                {
                    booking_id: id
                }
            ))
        await  dispatch (getAllRequestedAppointment({start_date: localStartDate ,end_date: localEndDate}))
        await   dispatch ( getUserDetails())
            setLoading(false)
            if (payload?.success === 'true') {
                toast.success('Appointment Approved Successfully')
            }   
        
    };
      const handleChangeStatus = async (id) => {   
                if (id) {
                    let finalData = {
                        appointment_id: id,
                        status: "Canceled"   
                    }
                            setLoading(true)
                            let res = await dispatch(changeAppointmentStatus(finalData))
                           
                            if (res?.payload?.success === "true") {
                                      await   dispatch ( getUserDetails())
                               dispatch (getAllRequestedAppointment({start_date: localStartDate, end_date: localEndDate }))
                              toast.success('Appointment Canceled Successfully')
    
                               
                            }
                            setLoading(false)
                        
                    }
                
            
        }  

    return (
      <Box sx={{ padding: { xs: "6px", sm:"20px" }}}>
    <Box sx={{ 
        display: 'flex', 
        flexDirection:{xs:"column",lg:"row"},
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 1
    }}>
        <Typography variant="h5" sx={{ 
            fontFamily: "helvetica-lt-std-bold",
            fontSize: "20px",
            color: "#1E293B",
              mb: 2
        }}>
         Appointment Needs to Approved
        </Typography>
        
        <Box sx={{ minWidth:{ xs: 235, sm: 315} }}>
    <DateRangeRequest  
setStartDate={setLocalStartDate}
setEndDate={setLocalEndDate}
startDate={localStartDate}
endDate={localEndDate}     
onChange={handleDateChange}   />  

 </Box> 
    </Box> 



    {/* <Divider sx={{ mb: 3 }} /> */}

 

{
    loading ? (
        <Box >
            <Waveloading />
        </Box>
    ) : (
        <Box sx={{

    mt: 2, 
    overflowY: 'auto',
    ...scrollCSS,
}}>
    {requestedAppointment?.data?.length > 0 ? (
        requestedAppointment.data.map((appointment, index) => (
            <Box
                key={index}
                sx={{
                    mb: 3,
                    background: "#fff",
                    borderRadius: "8px",
                    border: "1px solid #E2E8F0",
                    overflow: 'hidden',
                }}
            >
                {/* Header Section */}
                <Box 
                    sx={{ 
                        px: 3, 
                        py: 2,
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        backgroundColor: '#F8FAFC',
                        borderBottom: '1px solid #E2E8F0',
                        transition: 'background-color 0.2s ease'
                    }}
                >
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2
                    }}>
                        {/* Header Content */}
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            width: { xs: '100%', sm: 'auto' },
                            justifyContent: { xs: 'space-between', sm: 'flex-start' }
                        }}>

                            <Box sx={{
                                p: 1,
                                borderRadius: '50%',
                                backgroundColor: '#EFF6FF',
                                display: 'flex',

                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                            }}>
                                <PersonIcon sx={{ 
                                    color: "#3B82F6",
                                    fontSize: "20px"
                                }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{
                                    fontSize: "16px",
                                    fontFamily: "helvetica-lt-std-bold",
                                    color: "#1E293B",
                                    mb: 0.5 
                                }}>
                                    {appointment?.name}
                                </Typography>
                               
                            </Box>
                        </Box>


                        {/* Buttons - Mobile View */}
                        <Box sx={{
                            width: '100%',
                            display: { xs: 'flex', sm: 'none' },
                            flexDirection: 'column',
                            gap: 1,
                            mt: 2
                        }}>
                            <AppointmentReschedule
                                requestappointment
                                startDate={localStartDate}
                                endDate={localEndDate}
                                appointment={appointment}
                                isMouseEnter={isMouseEnter}
                                setIsMouseEnter={setIsMouseEnter}
                                isRequested={true}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<CheckCircleIcon />}
                                onClick={() => handleAccept(appointment?.id)}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    borderRadius: "17px",
                                    backgroundColor: "#10B981",
                                    '&:hover': { backgroundColor: "#059669" }
                                }}
                            >
                                Accept
                            </Button>
                            <Button
                                fullWidth
                                variant="outlined"
                                size="large"
                                startIcon={<EventBusyIcon />}
                                onClick={() => handleChangeStatus(appointment?.id)}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    borderRadius: "17px",
                                    color: "#DC2626",
                                    borderColor: "#FCA5A5",
                                    '&:hover': {
                                        backgroundColor: "#DC2626", 
                                        color: "#FFFFFF",            
                                        borderColor: "#DC2626",      
                                        '& .MuiSvgIcon-root': {
                                            color: "#FFFFFF",        
                                        },
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>

                        {/* Buttons - Desktop View */}
                        <Box sx={{
                            display: { xs: 'none', sm: "flex" },
                            justifyContent: "flex-end",
                            gap: 1,
                            px: 1,
                            pb: 1,
                            flexDirection: 'row'
                        }}>
                            <AppointmentReschedule
                                requestappointment
                                startDate={localStartDate}
                                endDate={localEndDate}
                                appointment={appointment}
                                isMouseEnter={isMouseEnter}
                                setIsMouseEnter={setIsMouseEnter}
                                isRequested={true}
                            />
                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<CheckCircleIcon />}
                                onClick={() => handleAccept(appointment?.id)}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    borderRadius: "17px",
                                    backgroundColor: "#10B981",
                                    '&:hover': { backgroundColor: "#059669" }
                                }}
                            >
                                Accept
                            </Button>
                            <Button
                                variant="outlined"
                                size="large"
                                startIcon={<EventBusyIcon />}
                                onClick={() => handleChangeStatus(appointment?.id)}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    borderRadius: "17px",
                                    color: "#DC2626",
                                    borderColor: "#FCA5A5",
                                    '&:hover': {
                                        backgroundColor: "#DC2626", 
                                        color: "#FFFFFF",            
                                        borderColor: "#DC2626",      
                                        '& .MuiSvgIcon-root': {
                                            color: "#FFFFFF",        
                                        },
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
                {/* Details Section */}
                <Box sx={{ p: 2 }}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: "11%",
                        px: 1,
                    }}>
                        {/* Contact Info */}
                        <Box sx={{
                            p: { xs: "6px", sm: 2},
                            borderRadius: '8px',
                             width: { xs: '100%', md: '25%' },
                        }}>
                            <Typography variant="body2" sx={{
                                color: "#64748B",
                                fontSize: "15px",
                                fontWeight: 'bold',
                                mb: 1
                            }}>
                                CONTACT INFORMATION
                            </Typography>
                            <Box sx={{ 
                                mb: 2, 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1 
                            }}>
                                <Box sx={{
                                    p: 1,
                                    borderRadius: '50%',
                                    backgroundColor: '#EFF6FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <PhoneIcon fontSize="small" sx={{ color: "#3B82F6" }} />
                                </Box>
                                <Typography variant="body2" sx={{ 
                                    color: "#1E293B", 
                                    fontSize: "16px" 
                                }}>
                                    {appointment?.phone}
                                </Typography>
                            </Box>
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center',  
                                gap: 1 
                            }}>
                                <Box sx={{
                                    p: 1,
                                    borderRadius: '50%',
                                    backgroundColor: '#EFF6FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <EmailIcon fontSize="small" sx={{ color: "#3B82F6" }} />
                                </Box>
                                <Typography variant="body2" sx={{ 
                                    color: "#1E293B", 
                                    fontSize: "16px" 
                                }}>
                                    {appointment?.email}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Appointment Details */}
                        <Box sx={{
                            p: { xs: "6px", sm: 2 },
                            borderRadius: '8px',
                             width: { xs: '100%', md: '25%' },
                        }}>
                            <Typography variant="body2" sx={{
                                color: "#64748B",
                                fontSize: "15px",
                                fontWeight: 'bold',
                                mb: 1
                            }}>
                                APPOINTMENT DETAILS
                            </Typography>
                            <Box sx={{ 
                                mb: 2, 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1 
                            }}>
                                <Box sx={{
                                    p: 1,
                                    borderRadius: '50%',
                                    backgroundColor: '#EFF6FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <CalendarTodayIcon fontSize="small" sx={{ color: "#3B82F6" }} />
                                </Box>
                                <Typography variant="body2" sx={{ color: "#1E293B", fontSize: "16px" }}>
                                    {moment(appointment?.date).format('dddd MMMM D, YYYY')}
                                </Typography>
                            </Box>
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1 
                            }}>
                                <Box sx={{
                                    p: 1,
                                    borderRadius: '50%',
                                    backgroundColor: '#EFF6FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <AccessTimeIcon fontSize="small" sx={{ color: "#3B82F6" }} />
                                </Box>
                                <Typography variant="body2" sx={{ color: "#1E293B", fontSize: "16px" }}>
                                    {appointment?.start_time} - {appointment?.end_time}
                                </Typography>
                            </Box>
                        </Box>
                        <Box  sx={{
                            p: { xs: "6px", sm: 2 },
                            borderRadius: '8px',
                             width: { xs: '100%', md: '20%' },
                        }}>
                            <Typography variant="body2" sx={{
                                color: "#64748B",
                                fontSize: "15px",
                                fontWeight: 'bold',
                                mb: 1
                            }}>
                                Service
                            </Typography>

                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1 
                            }}>
                                <Box sx={{
                                    p: 1,
                                    borderRadius: '50%',
                                    backgroundColor: '#EFF6FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <MedicalServicesOutlinedIcon fontSize="small" sx={{ color: "#3B82F6" }} />
                                </Box>
                                <Typography variant="body2" sx={{
                                    color: "#1E293B",
                                    fontSize: "16px",
                                    fontWeight:700,
                                }}>
                                    {appointment?.services_name?.join(', ')}
                                </Typography>
                            </Box>
                           
                            </Box>
                    </Box>
                </Box>
            </Box>
        ))
    ) : (
        <Box
            sx={{
                mt: 2,
                background: "#fff",
                p: 3,
                borderRadius: 2,
                border: "1px solid #E2E8F0",
                textAlign: 'center'
            }}
        >
            <Typography variant="body1" sx={{ color: "#64748B" }}>
                No Requested Appointment found.
            </Typography>
        </Box>
    )}
</Box>
    )
}


</Box>
    );
};

 
export default RequestedAppointment;
